import React from 'react';

import { SelectionDropdown } from 'shared/components/dropdown/SelectionDropdown';
import * as Styled from 'settings/styles/PillField.style';

export type PillSelectOption = {
  value: string;
  label: string;
};

interface PillSelectProps {
  ariaLabel: string;
  value: string;
  options: PillSelectOption[];
  onChange: (value: string) => void;
}

export default function PillSelect({
  ariaLabel,
  value,
  options,
  onChange,
}: PillSelectProps): JSX.Element {
  return (
    <Styled.PillFormControl size="small">
      <SelectionDropdown
        ariaLabel={ariaLabel}
        value={value}
        options={options}
        onChange={onChange}
        fullWidth
      />
    </Styled.PillFormControl>
  );
}
